import request from '@/axios'

export function buildGiftCode(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/gift/buildGiftCode',
    method: 'post',
    data
  })
}

export function getCustomerServiceInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/Store_Manager/getCustomerServiceInfo',
    method: 'post',
    data
  })
}

// SC-01-门店用户统计
export function getUserStatistics(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_user/getUserStatistics',
    method: 'post',
    data
  })
}

// SC-02-门店用户列表
export function getUserList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_user/getUserList',
    method: 'post',
    data
  })
}
// SC-02-门店用户列表
export function getCardInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/Store_Manager/getCardInfo',
    method: 'post',
    data
  })
}
// R00-获取设计方案的明细列表
export function getDesignDetailsList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/Store_Manager/getDesignDetailsList',
    method: 'post',
    data
  })
}
// 阶段判断
export function getFilePhasesType(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_manager/getFilePhasesType',
    method: 'post',
    data
  })
}
